import React from 'react';
import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Bishwoshundori from '../../Images/Bishwoshundori.jpg';
import cineplex from '../../Images/1917-cineplex.jpg';
import Tenet from '../../Images/Tenet.jpg';

const LatestMovies = () => {
    return (
        <div className="mt-5 text-center container">
            <h2>Latest Movies</h2>
             <Carousel>
                <div>
                    <img src={Bishwoshundori} />
                    <p className="legend">বিশ্বসুন্দরী</p>
                </div>
                <div>
                    <img src={cineplex} />
                    <p className="legend">1917</p>
                </div>
                <div>
                    <img src={Tenet} />
                    <p className="legend">Tenet</p>
                </div>
            </Carousel>
        </div>
    );
};

export default LatestMovies;